import { Component, Input, ChangeDetectionStrategy } from '@angular/core';
import { CommonModule } from '@angular/common';

export type GlassIntensity = 'light' | 'medium' | 'heavy' | 'dark';

@Component({
  selector: 'app-glass-card',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './glass-card.component.html',
  styleUrls: ['./glass-card.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class GlassCardComponent {
  @Input() intensity: GlassIntensity = 'light';
  @Input() noPadding: boolean = false;
  @Input() interactive: boolean = false;
}
